import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo, useState } from "react";
import { usePureStudentUrls } from "@crehana/auth";
import { useCourseEnrollments } from "../hooks/useCourseEnrollments";
import { LAST_ACTIVITY_AMPLITUDE_SECTION_NAME, USER_DASHBOARD_BOOTCAMP_URL, USER_DASHBOARD_MICRODEGREE_URL } from "../constants";
import LearnLastActivityContext from "./LearnLastActivityContext";
import { jsx as _jsx } from "react/jsx-runtime";
var LearnLastActivityProvider = function LearnLastActivityProvider(_ref) {
  var children = _ref.children,
    me = _ref.me,
    containerType = _ref.containerType,
    userDashboardUrl = _ref.userDashboardUrl,
    userDashboardMicrodegreeUrl = _ref.userDashboardMicrodegreeUrl,
    amplitudePageName = _ref.amplitudePageName,
    disableRedirections = _ref.disableRedirections,
    catalogUrl = _ref.catalogUrl,
    onEditTastes = _ref.onEditTastes,
    onGoToCatalog = _ref.onGoToCatalog,
    onGoToPlayer = _ref.onGoToPlayer,
    onEnrollToCourse = _ref.onEnrollToCourse,
    onGoToInbox = _ref.onGoToInbox,
    isDark = _ref.isDark,
    onGoToCourseDetail = _ref.onGoToCourseDetail,
    className = _ref.className,
    onGoToUserDashboard = _ref.onGoToUserDashboard,
    setHasEnrollments = _ref.setHasEnrollments,
    userDashboardBootcampUrl = _ref.userDashboardBootcampUrl,
    feedbackUrl = _ref.feedbackUrl,
    newCoursesCatalogUrl = _ref.newCoursesCatalogUrl,
    playroomQuizCoinValue = _ref.playroomQuizCoinValue,
    playroomCoursesCoinValue = _ref.playroomCoursesCoinValue,
    playroomProjectCoinValue = _ref.playroomProjectCoinValue,
    hideSliderNewCourses = _ref.hideSliderNewCourses,
    onGoToB2BTracksDetail = _ref.onGoToB2BTracksDetail,
    onGoToMicroDegreeDashboard = _ref.onGoToMicroDegreeDashboard,
    onGoToProject = _ref.onGoToProject,
    onGoToNewCoursesCatalog = _ref.onGoToNewCoursesCatalog,
    onGoToStartProjectTab = _ref.onGoToStartProjectTab,
    onGoToContentForYou = _ref.onGoToContentForYou,
    onGoToQuiz = _ref.onGoToQuiz;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    mentors = _useState2[0],
    setMentors = _useState2[1];
  // @ts-expect-error Type 'MeObject' is not assignable to type 'Pick<MeObject, "isActiveDegree" | "isB2B" | "isPremium" | "organization"> | undefined'.
  var _usePureStudentUrls = usePureStudentUrls({
      me: me
    }),
    myCoursesUrl = _usePureStudentUrls.myCoursesUrl;
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    stateLearning = _useState4[0],
    setStateLearning = _useState4[1];
  var studentType = useMemo(function () {
    var _studentType = 'payg';
    if (me.isActiveDegree) {
      _studentType = 'degree';
    } else if (me.isB2B) {
      _studentType = 'b2b';
    } else if (me.isPremium) {
      if (me.isPremiumTrial) {
        _studentType = 'premium-trial';
      } else {
        _studentType = 'premium';
      }
    } else if (me.isNewUser) {
      _studentType = 'register';
    }
    return _studentType;
  }, [me]);
  var _useCourseEnrollments = useCourseEnrollments({
      student: studentType
    }),
    loading = _useCourseEnrollments.loading,
    error = _useCourseEnrollments.error,
    totalCount = _useCourseEnrollments.totalCount,
    courseEnrollments = _useCourseEnrollments.courseEnrollments;
  // Save the total enrollments count without any filter applied
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    totalEnrollmentsCount = _useState6[0],
    setTotalEnrollmentsCount = _useState6[1];
  // Save the last activity course without any filter applied
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    mostRecentCourse = _useState8[0],
    setMostRecentCourse = _useState8[1];
  var hasEnrollments = !!totalEnrollmentsCount || !!totalCount;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    var firstCourseEnrollmentFromList = courseEnrollments[0];
    if (!mostRecentCourse && firstCourseEnrollmentFromList) {
      setMostRecentCourse(courseEnrollments[0]);
    }
    if (totalCount > totalEnrollmentsCount) {
      setTotalEnrollmentsCount(totalCount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalCount]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (setHasEnrollments && hasEnrollments) {
      setHasEnrollments(hasEnrollments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEnrollments]);
  return /*#__PURE__*/_jsx(LearnLastActivityContext.Provider, {
    value: {
      me: me,
      error: error,
      loading: loading,
      mentors: mentors,
      totalCount: totalCount,
      studentType: studentType,
      hasEnrollments: hasEnrollments,
      mostRecentCourse: mostRecentCourse,
      courseEnrollments: courseEnrollments,
      disableRedirections: disableRedirections,
      hideSliderNewCourses: hideSliderNewCourses,
      totalEnrollmentsCount: totalEnrollmentsCount,
      playroomQuizCoinValue: playroomQuizCoinValue,
      playroomProjectCoinValue: playroomProjectCoinValue,
      playroomCoursesCoinValue: playroomCoursesCoinValue,
      containerType: containerType || 'default',
      userDashboardUrl: userDashboardUrl || myCoursesUrl,
      userDashboardMicrodegreeUrl: userDashboardMicrodegreeUrl || USER_DASHBOARD_MICRODEGREE_URL,
      userDashboardBootcampUrl: userDashboardBootcampUrl || USER_DASHBOARD_BOOTCAMP_URL,
      source: amplitudePageName,
      sourceDetail: LAST_ACTIVITY_AMPLITUDE_SECTION_NAME,
      setMentors: setMentors,
      setMostRecentCourse: setMostRecentCourse,
      setTotalEnrollmentsCount: setTotalEnrollmentsCount,
      catalogUrl: catalogUrl,
      onEditTastes: onEditTastes,
      onGoToCatalog: onGoToCatalog,
      onGoToPlayer: onGoToPlayer,
      onEnrollToCourse: onEnrollToCourse,
      onGoToInbox: onGoToInbox,
      isDark: isDark,
      onGoToCourseDetail: onGoToCourseDetail,
      className: className,
      onGoToUserDashboard: onGoToUserDashboard,
      setHasEnrollments: setHasEnrollments,
      feedbackUrl: feedbackUrl,
      newCoursesCatalogUrl: newCoursesCatalogUrl,
      onGoToB2BTracksDetail: onGoToB2BTracksDetail,
      onGoToMicroDegreeDashboard: onGoToMicroDegreeDashboard,
      onGoToProject: onGoToProject,
      onGoToNewCoursesCatalog: onGoToNewCoursesCatalog,
      onGoToStartProjectTab: onGoToStartProjectTab,
      onGoToContentForYou: onGoToContentForYou,
      onGoToQuiz: onGoToQuiz,
      canStateLearning: setStateLearning,
      stateLearning: stateLearning
    },
    children: children
  });
};
export default LearnLastActivityProvider;